/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import IntegrationRoutes from './integration.routes';
import AddIntegrationController from './add-integration.controller';
import IntegrationDirective from './integration.directive';
import IntegrationTableConfig from './integration-table.config';
import IntegrationRetryStatisticsController from './integration-retry-statistics.controller';
import IntegrationDeliveryStatisticsController from './integration-delivery-statistics.controller';
import IntegrationDlStatisticsController from './integration-dl-statistics.controller';

export default angular.module('tektelic.integration', [])
    .config(IntegrationRoutes)
    .controller('AddIntegrationController', AddIntegrationController)
    .controller('IntegrationRetryStatisticsController', IntegrationRetryStatisticsController)
    .controller('IntegrationDeliveryStatisticsController', IntegrationDeliveryStatisticsController)
    .controller('IntegrationDlStatisticsController', IntegrationDlStatisticsController)
    .directive('tkIntegration', IntegrationDirective)
    .factory('integrationTableConfig', IntegrationTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/integration/index.js